// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallDescription__container-b36dc2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;
}

.CallDescription__image-bdaa40 {
  width: 120px;
  height: 120px;
  margin-bottom: 24px;
}

.CallDescription__title-d8aac7 {
  color: var(--base-110);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}

.CallDescription__sub-title-b1b262 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  word-break: break-word;
}

.CallDescription__textBlock-d00e11 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

@media (max-width: 1024px) {
  .CallDescription__image-bdaa40 {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
    font: var(--font-title-7);
    letter-spacing: var(--font-spacing-title-7);
  }
  .CallDescription__title-d8aac7 {
    font: var(--font-title-8);
    letter-spacing: var(--font-spacing-title-8);
  }
}
@media (max-width: 768px) {
  .CallDescription__image-bdaa40 {
    width: 48px;
    height: 48px;
    margin-bottom: 0;
    margin-inline-end: 14px;
    font: var(--font-title-9);
    letter-spacing: var(--font-spacing-title-9);
  }
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/RoomCallPreviewPopup/StartCall/CallDescription/CallDescription.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;IACA,yBAAA;IACA,2CAAA;EACF;EACA;IACE,yBAAA;IACA,2CAAA;EACF;AACF;AAEA;EACE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,2CAAA;EAAF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.image {\n  width: 120px;\n  height: 120px;\n  margin-bottom: 24px;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n\n.sub-title {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  word-break: break-word;\n}\n\n.textBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n@media (max-width: 1024px) {\n  .image {\n    width: 72px;\n    height: 72px;\n    margin-bottom: 16px;\n    font: var(--font-title-7);\n    letter-spacing: var(--font-spacing-title-7);\n  }\n  .title {\n    font: var(--font-title-8);\n    letter-spacing: var(--font-spacing-title-8);\n  }\n}\n\n@media (max-width: 768px) {\n  .image {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 0;\n    margin-inline-end: 14px;\n    font: var(--font-title-9);\n    letter-spacing: var(--font-spacing-title-9);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallDescription__container-b36dc2`,
	"image": `CallDescription__image-bdaa40`,
	"title": `CallDescription__title-d8aac7`,
	"sub-title": `CallDescription__sub-title-b1b262`,
	"subTitle": `CallDescription__sub-title-b1b262`,
	"textBlock": `CallDescription__textBlock-d00e11`
};
module.exports = ___CSS_LOADER_EXPORT___;
